export default __webpack_public_path__ + "static/media/DeleteIcon.630ee85e.svg";